module.exports = __webpack_public_path__ + "img/placeholder.f3a872b4.jpg";